import React from "react";
import { useTranslation } from "react-i18next";
import { FiArrowRight, FiCheck, FiMessageCircle } from "react-icons/fi";
import "./style.min.css";

const PricingSection = ({ variant = "full" }) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const isCompact = variant === "compact";
  const plans = t("pricing.plans", { returnObjects: true }) || [];
  const visiblePlans = isCompact ? plans.slice(0, 3) : plans;
  const isExternalLink = (link) => /^https?:\/\//.test(link);

  return (
    <section
      id={isCompact ? "budget-preview" : "budgets"}
      dir={lang === "ar" ? "rtl" : "ltr"}
      className={`pricing-section ${isCompact ? "pricing-section--compact" : ""}`}
    >
      <div className="pricing-heading">
        <span className="pricing-eyebrow">{t("pricing.eyebrow")}</span>
        <h2>{isCompact ? t("pricing.compactTitle") : t("pricing.title")}</h2>
        <p>{isCompact ? t("pricing.compactSubtitle") : t("pricing.subtitle")}</p>
      </div>

      <div className="pricing-grid">
        {visiblePlans.map((plan, index) => (
          <article
            className={`pricing-card ${plan.featured ? "pricing-card--featured" : ""}`}
            key={plan.title}
            style={{ "--card-index": index }}
          >
            {plan.featured && (
              <span className="pricing-badge">{t("pricing.recommended")}</span>
            )}

            <div className="pricing-card-head">
              <span className="pricing-kind">{plan.kind}</span>
              <h3>{plan.title}</h3>
              <p>{plan.description}</p>
            </div>

            <div className="pricing-price">
              <span>{plan.prefix}</span>
              <strong>{plan.price}</strong>
            </div>

            <ul className="pricing-features">
              {plan.features.map((feature) => (
                <li key={feature}>
                  <FiCheck />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>

            <a
              className="pricing-link"
              href={plan.link}
              target={isExternalLink(plan.link) ? "_blank" : undefined}
              rel={isExternalLink(plan.link) ? "noopener noreferrer" : undefined}
            >
              {plan.cta}
              <FiArrowRight />
            </a>
          </article>
        ))}
      </div>

      {!isCompact && (
        <div className="pricing-note">
          <FiMessageCircle />
          <p>{t("pricing.note")}</p>
        </div>
      )}

      {isCompact && (
        <div className="pricing-compact-action">
          <a href="/services#budgets">
            {t("pricing.compactCta")}
            <FiArrowRight />
          </a>
        </div>
      )}
    </section>
  );
};

export default PricingSection;
